import React, {Component} from 'react';
import SwitcherBox from './switcherBox.js';
import PopupSubMenu from './popupSubMenu.js';
import Slider from 'react-rangeslider';

export default class Overlay extends Component {
        
    constructor() {
        super();
        this.state = {};
    }
    
    componentDidMount() {
        this.props.updateState(this.setState.bind(this));
        this.setState(this.props.state);
    }
    
    formatNumber(number,digits){
        if (typeof(number) === 'undefined'){
            return false;
        }
        if (typeof(digits) === 'undefined'){
            return number+'';
        }
        return number.toLocaleString(navigator.language, { minimumFractionDigits: digits, maximumFractionDigits: digits });
    }

    createMarkup(translationKey) {
        let text = this.props.functions.translate(translationKey);
        if (text.startsWith("<p>") && text.endsWith("</p>")) {
            text = text.substr(3, text.length - 7);
        }
        return {
            __html: text
        };
    }

    render() {
        const moreThenOneHighlight = this.props.features.highlights.length > 1;

        //console.log(this.props.features.highlights);

        return(
            <div>
                {(this.state.loadingProgress < 100 || this.state.showIntro) &&
                <section className="info-box" onClick={() => this.props.functions.toggle('showIntro')}>
                    {this.state.loadingProgress < 100 &&
                    <div className="loading-box">
                        <h2>{this.props.functions.translate('dastudio.loading')} <span id="partNumber"></span></h2>
                        <div className="progress">
                            <div className="indeterminate"></div>
                        </div>
                    </div>
                    }
                    {this.state.showIntro &&
                        <div dangerouslySetInnerHTML={{ __html: this.props.functions.translate(this.props.features.introText)}}></div>
                    }
                </section>
                }
                
                {this.state.showInfo &&
                <section className="info-box" onClick={() => this.props.functions.toggle('showInfo')}>
                    <p>
                        <strong>{this.props.functions.translate('dastudio.pand')}</strong><br/>
                        <span className="small-caps">Utz Group</span><br />
                        Internet: <a href="https://www.utzgroup.com" target="_blank">www.utzgroup.com</a><br />
                    </p>
                    <p
                        dangerouslySetInnerHTML={this.createMarkup('dastudio.info.text')}>
                    </p>    
                </section>
                }


                {this.props.features.highlights.length > 0 && this.state.highlights &&
                <section className="annotation">
                    {this.state.highlightList &&
                        <div className="annotation-top">
                        {
                            false && <div className={"autopilot " + (this.state.autopilot ? "active" : "")} onClick={() => this.props.functions.toggle('autopilot')}>
                                {!this.state.autopilot &&
                                    <div>
                                        <svg fill="#ffffff" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8 5v14l11-7z" />
                                            <path d="M0 0h24v24H0z" fill="none" />
                                        </svg>
                                        <span>{this.props.functions.translate('dastudio.autopilot.start')}</span>
                                    </div>
                                }

                                {this.state.autopilot &&
                                    <span>{this.props.functions.translate('dastudio.autopilot.stop')}</span>
                                }
                            </div>
                        }
                        
                        
                        <div className="annotation-list">
                            <ul>
                            {this.props.features.highlights.map((element,index) => {
                                return (
                                    <li 
                                        key={'highight-' + index} 
                                        id={index}
                                        onClick={() => this.props.functions.setActiveHighlight(index, !this.state.timelineVisible)}
                                        onMouseEnter={() => this.props.functions.hoverHighlight(index,true)}
                                        onMouseLeave={() => this.props.functions.hoverHighlight(index, false)}
                                        dangerouslySetInnerHTML={this.createMarkup(this.props.functions.translate(element.headline))}
                                    >
                                    </li>
                                );
                            })}
                            </ul>
                        </div>
                    </div>
                    }
                    <div className="annotation-bottom">
                        {moreThenOneHighlight &&
                            <a className="left_arrow" href="#" title={this.props.functions.translate('dastudio.highlight.previous')} onClick={() => this.props.functions.setActiveHighlight(this.state.activeHighlight - 1, !this.state.timelineVisible)}>
                            <svg fill="#ffffff" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" />
                                <path d="M0-.5h24v24H0z" fill="none" />
                            </svg>
                        </a>
                        }
                        <div className="highlight-list-btn" data-title={moreThenOneHighlight ? this.props.functions.translate('dastudio.highlight.list') : null} onClick={() => moreThenOneHighlight ? this.props.functions.toggle('highlightList') : this.props.functions.setActiveHighlight(0, !this.state.timelineVisible)}>
                            <div dangerouslySetInnerHTML={this.createMarkup(this.props.functions.translate(this.props.features.highlights[this.state.activeHighlight].headline))}>

                            </div>
                        </div>
                        {moreThenOneHighlight &&
                            <a className="right_arrow" href="#" title={this.props.functions.translate('dastudio.highlight.next')} onClick={() => this.props.functions.setActiveHighlight(this.state.activeHighlight + 1, !this.state.timelineVisible)}>
                            <svg fill="#ffffff" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
                                <path d="M0-.25h24v24H0z" fill="none" />
                            </svg>
                        </a>
                        }
                        
                    </div>
                </section>
                }
                
                
                {this.props.features.settings && this.state.boxSettings && 
                <section className="popup_window">
                    <ul>
                        <SwitcherBox 
                            checked={this.state.rotate}
                            name="rotate" 
                            onChange={() => this.props.functions.toggle('rotate')}
                            text={this.props.functions.translate('dastudio.rotate')}
                        ></SwitcherBox>

                        <SwitcherBox
                            checked={this.state.animatedHighlights}
                            name="hl-anim"
                            onChange={() => this.props.functions.toggle('animatedHighlights')}
                            text={"Kamerfahrten"}
                        ></SwitcherBox>
                        
                        {this.props.features.floaty &&
                        <SwitcherBox 
                            checked={this.state.floaty}
                            name="floaty" 
                            onChange={() => this.props.functions.toggle('floaty')}
                            text={this.props.functions.translate('dastudio.floaty')}
                        ></SwitcherBox>
                        }
                        
                        {this.props.features.wireframe &&
                        <SwitcherBox 
                            checked={this.state.wireframe}
                            name="wireframe" 
                            onChange={() => this.props.functions.toggle('wireframe')}
                            text={this.props.functions.translate('dastudio.wireframe')}
                        ></SwitcherBox>
                        }
                        
                        {this.props.features.highlights && this.props.features.highlightsAvailable &&
                        <SwitcherBox 
                            checked={this.state.highlights}
                            name="highlights" 
                            onChange={() => this.props.functions.toggle('highlights')}
                            text={this.props.functions.translate('dastudio.highlights')}
                        ></SwitcherBox>
                        }
                        
                        {this.props.features.postprocessing &&
                        <SwitcherBox 
                            checked={this.state.postprocessing}
                            name="postprocessing" 
                            onChange={() => this.props.functions.toggle('postprocessing')}
                            text={this.props.functions.translate('dastudio.postprocessing')}
                        ></SwitcherBox>
                        }
                        
                        {this.props.features.postprocessing && this.state.postprocessing &&
                        <PopupSubMenu target="postprocessing" subMenus={this.state.subMenus} onClick={() => this.props.functions.toggleSubMenu('postprocessing')}>
                            {this.props.features.ppBloom &&
                            <SwitcherBox 
                                checked={this.state.ppBloom}
                                name="ppBloom" 
                                onChange={() => this.props.functions.toggle('ppBloom')}
                                text={this.props.functions.translate('dastudio.bloom')}
                            ></SwitcherBox>
                            }

                            {this.props.features.ppEdgeglow &&
                            <SwitcherBox 
                                checked={this.state.ppEdgeglow}
                                name="ppEdgeglow" 
                                onChange={() => this.props.functions.toggle('ppEdgeglow')}
                                text={this.props.functions.translate('dastudio.edgeglow')}
                            ></SwitcherBox>
                            }

                            {this.props.features.ppFxaa &&
                            <SwitcherBox 
                                checked={this.state.ppFxaa}
                                name="ppFxaa" 
                                onChange={() => this.props.functions.toggle('ppFxaa')}
                                text={this.props.functions.translate('dastudio.fxaa')}
                            ></SwitcherBox>
                            }

                            {this.props.features.ppSsao &&
                            <SwitcherBox 
                                checked={this.state.ppSsao}
                                name="ppSsao" 
                                onChange={() => this.props.functions.toggle('ppSsao')}
                                text={this.props.functions.translate('dastudio.ssao')}
                            ></SwitcherBox>
                            }

                            {this.props.features.ppTaa &&
                            <SwitcherBox 
                                checked={this.state.ppTaa}
                                name="ppTaa" 
                                onChange={() => this.props.functions.toggle('ppTaa')}
                                text={this.props.functions.translate('dastudio.taa')}
                            ></SwitcherBox>
                            }

                            {this.props.features.ppDof &&
                            <SwitcherBox 
                                checked={this.state.ppDof}
                                name="ppDof" 
                                onChange={() => this.props.functions.toggle('ppDof')}
                                text={this.props.functions.translate('dastudio.dof')}
                            ></SwitcherBox>
                            }
                        </PopupSubMenu>
                        }
                    </ul>
                </section>
                }
                
                
                {this.state.boxLanguages && this.props.features.languages.length > 1 &&
                <section className="popup_window">
                    <ul>                        
                    {this.props.features.languages.map((element,index) => {
                        return(
                            <li className="radio-box" key={'lightSetup-'+index}>
                                <label htmlFor={'btn-language-'+index}>
                                    {this.props.functions.translate('dastudio.'+element)}
                                    <input 
                                        id={'btn-language-'+index}
                                        type="radio" name="language" 
                                        checked={this.state.activeLanguage === element} 
                                        value={element} 
                                        onChange={() => this.props.functions.setActiveLanguage(element)} 
                                    />
                                    <div className="radio-btn"></div>
                                </label>
                            </li>
                        );
                    })}
                    </ul>
                </section>
                }
                
                
                {this.state.boxLights &&
                <section className="popup_window">
                    <ul>                        
                    {this.props.features.lightSetups.map((element,index) => {
                        return(
                            <li className="radio-box" key={'lightSetup-'+index}>
                                <label htmlFor={'btn-lightSetup-'+index}>
                                    {this.props.functions.translate(element.name)}
                                    <input 
                                        id={'btn-lightSetup-'+index}
                                        type="radio" name="lightSetup" 
                                        checked={this.state.activeLight === element.name} 
                                        value={element.name} 
                                        onChange={() => this.props.functions.setActiveLightSetup(element.name)} 
                                    />
                                    <div className="radio-btn"></div>
                                </label>
                            </li>
                        );
                    })}
                    </ul>
                </section>
                }


                {this.state.boxColors && 
                <section className="materials popup_window">
                    <ul className="color-list">
                    {this.state.activeMaterial.options.map((element,index) => {
                        return(
                            <li key={'color-'+index}>
                                <button 
                                    style={{background: element.color, borderColor: element.color}} 
                                    className={'material' + (element.name === this.state.activeColors[this.state.activeMaterial.name]?' active':'')} 
                                    data-title={this.props.functions.translate(element.name)} 
                                    onClick={() => this.props.functions.changeMaterialColor(element,this.state.activeMaterial.name)}>
                                </button>
                            </li>
                        );
                    })}
                    </ul>
                    
                    {this.props.features.changeMaterials.length > 1 &&
                    <ul className="material-list">                        
                    {this.props.features.changeMaterials.map((element,index) => {
                        return(
                            <li key={'material-'+index}>
                                <label htmlFor="color-{element.name}">
                                    {this.props.functions.translate(element.name)}
                                    <input 
                                        type="radio" name="uk" 
                                        id="color-{element.name}"
                                        checked={this.state.activeColor.name === element.name} 
                                        value={element.name} 
                                        onChange={() => this.props.functions.setActiveMaterial(element)} 
                                    />
                                </label>
                            </li>
                        );
                    })
                    }
                    </ul>
                    }
                </section>
                }
                
                
                {this.state.boxAnimations && 
                <section className="popup_window">
                    <ul className="animation-list">                        
                    {this.props.features.animationNames.map((element,index) => {
                        return(
                            <li key={'animation-'+index}>
                                <label htmlFor="animation-{element}">
                                    {element}
                                    <input 
                                        type="radio" name="uk" 
                                        id="animation-{element}"
                                        checked={this.state.activeAnimation === element} 
                                        value={this.props.functions.translate(element)} 
                                        onChange={() => this.props.functions.setActiveAnimation(element)} 
                                    />
                                </label>
                            </li>
                        );
                    })
                    }
                    </ul>        
                </section>
                }


                <section className="actionbuttons">
                    {this.props.features.fullscreen && 
                    <button className="round-btn" data-title={this.props.functions.translate('dastudio.fullscreen')} onClick={() => this.props.functions.toggle('fullscreen')}>
                        <svg fill="#ffffff" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 0h24v24H0z" fill="none"/>
                            <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
                        </svg>
                    </button>
                    }
                    
                    {this.props.features.settings && 
                    <button className="round-btn" data-title={this.props.functions.translate('dastudio.settings')} onClick={() => this.props.functions.toggle('boxSettings')}>
                        <svg fill="#ffffff" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 0h24v24H0z" fill="none"/>
                            <path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"/>
                        </svg>
                    </button>
                    }
                    
                    {this.props.features.languages.length > 1 && this.props.state.showLanguage &&
                    <button className="round-btn languageSwitch" data-title={this.props.functions.translate('dastudio.languages')} onClick={() => this.props.functions.toggle('boxLanguages')}>
                        {this.state.activeLanguage}
                    </button>
                    }
                    
                    {this.props.features.changeMaterials.length > 0 &&
                    <button className="round-btn" data-title={this.props.functions.translate('dastudio.changematerials')} onClick={() => this.props.functions.toggle('boxColors')}>
                        <svg fill="#ffffff" version="1.1" baseProfile="tiny" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" 
                            x="0px" y="0px" viewBox="0 0 24 24" width="24" height="24" overflow="auto">
                        <path fill="none" d="M0,0h24v24H0V0z"/>
                        <path d="M16.6,12.4l-9-8.9L6.2,4.9l2.4,2.4l-5.2,5.2c-0.6,0.6-0.6,1.5,0,2.1l5.5,5.5c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4
                            l5.5-5.5C17.1,14,17.1,13,16.6,12.4z M5.2,13.5L10,8.7l4.8,4.8H5.2z M19,15c0,0-2,2.2-2,3.5c0,1.1,0.9,2,2,2s2-0.9,2-2
                            C21,17.2,19,15,19,15z"/>
                        </svg>
                    </button>
                    }
                    
                    {this.props.features.lightSetups.length > 1 &&
                    <button className="round-btn" data-title={this.props.functions.translate('dastudio.lightsetups')} onClick={() => this.props.functions.toggle('boxLights')}>
                       <svg fill="#ffffff" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <path d="M0 0h24v24H0V0z" id="a"/>
                            </defs>
                            <clipPath id="b">
                                <use overflow="visible"/>
                            </clipPath>
                            <path clip-path="url(#b)" d="M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z"/>
                        </svg>
                    </button>
                    }
                    
                    {this.props.features.animations && this.props.features.animationNames.length > 1 &&
                    <button className="round-btn" data-title={this.props.functions.translate('dastudio.animations')} onClick={() => this.props.functions.toggle('boxAnimations')}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 40">
                            <circle cx="60" cy="20" r="20" style={{fill:'#fff'}}/>
                            <path d="M66,63A19.99,19.99,0,0,1,82.525,43.322,19.675,19.675,0,0,0,79,43a20,20,0,0,0,0,40,19.675,19.675,0,0,0,3.525-.322A19.99,19.99,0,0,1,66,63Z" transform="translate(-29 -43)" style={{fill:'#fff', fillOpacity:0.8}}/>
                            <path d="M56,63A19.99,19.99,0,0,1,72.525,43.322,19.675,19.675,0,0,0,69,43a20,20,0,0,0,0,40,19.675,19.675,0,0,0,3.525-.322A19.99,19.99,0,0,1,56,63Z" transform="translate(-29 -43)" style={{fill:'#fff', fillOpacity:0.6}}/>
                            <path d="M46,63A19.99,19.99,0,0,1,62.525,43.322,19.675,19.675,0,0,0,59,43a20,20,0,0,0,0,40,19.675,19.675,0,0,0,3.525-.322A19.99,19.99,0,0,1,46,63Z" transform="translate(-29 -43)" style={{fill:'#fff', fillOpacity:0.4}}/>
                            <path d="M36,63A19.99,19.99,0,0,1,52.525,43.322,19.675,19.675,0,0,0,49,43a20,20,0,0,0,0,40,19.675,19.675,0,0,0,3.525-.322A19.99,19.99,0,0,1,36,63Z" transform="translate(-29 -43)" style={{fill:'#fff', fillOpacity:0.2}}/>
                        </svg>
                    </button>
                    }

                    {this.props.features.hideTimelineAfterFirstPlay && !this.state.timelineVisible &&
                        <button className="round-btn" data-title={this.props.functions.translate('dastudio.resetAnimation')} onClick={() => this.props.functions.resetAnimation()}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                            <path style={{ fill: '#fff' }} d="M14,12a2,2,0,1,0-2,2A2.006,2.006,0,0,0,14,12ZM12,3a9,9,0,0,0-9,9H0l4,4,4-4H5a7,7,0,1,1,2.94,5.7L6.52,19.14A9,9,0,1,0,12,3Z" transform="translate(-1.2 -1)" />
                            </svg>
                        </button>
                    }
                </section>
                
                {this.props.features.info && 
                <button id="info-btn" data-title={this.props.functions.translate('dastudio.info')} onClick={() => this.props.functions.toggle('showInfo')}>
                    <img src="../app/img/Schwungmasse.svg" alt="DIE ALCHEMISTEN AG" />
                </button>
                }
                
                
                {this.props.features.animations && this.state.timelineVisible &&
                <section className="animation-controls">
                    {!this.state.animationPlaying &&
                    <button className="round-btn" data-title={this.props.functions.translate('dastudio.animation.play')} onClick={() => this.props.functions.toggle('animationPlaying')}>
                        <svg fill="#ffffff" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 5v14l11-7z"/>
                            <path d="M0 0h24v24H0z" fill="none"/>
                        </svg>
                    </button>
                    }
                    {this.state.animationPlaying &&
                    <button className="round-btn" data-title={this.props.functions.translate('dastudio.animation.stop')} onClick={() => this.props.functions.toggle('animationPlaying')}>
                        <svg fill="#ffffff" height="24" width="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <rect y="5" x="6" width="4" height="14"/>
                            <rect y="5" x="14" width="4" height="14"/>
                        </svg>
                    </button>
                    }
                    <span className="time">{this.formatNumber(this.state.animationTime,2)} / {this.formatNumber(this.state.animationLength,2)} s</span>
                    <Slider 
                        min={0}
                        max={this.state.animationLength}
                        value={this.state.animationTime}
                        step={0.0001}
                        tooltip={false}
                        orientation="horizontal"
                        onChangeStart={this.props.functions.aniHandleChangeStart}
                        onChange={this.props.functions.aniHandleChange}
                        onChangeComplete={this.props.functions.aniHandleChangeComplete}
                    >
                    </Slider>
                </section>
                }
                
                /*
                Highlight positioning
                n = nearest corner
                c = center
                rt = right top
                lt = left top
                rb = right bottom
                lb = left bottom
                tc = top center
                bc = bottom center
                lc = left center
                rc = right center
                 */
                {this.state.highlightDetail && this.state.highlights && this.props.features.highlights[this.state.activeHighlight] &&
                <section className="highlight" onClick={() => this.props.functions.toggle('highlightDetail')}>
                    <h3 dangerouslySetInnerHTML={this.createMarkup(this.props.functions.translate(this.props.features.highlights[this.state.activeHighlight].headline))}></h3>
                    {this.props.features.highlights[this.state.activeHighlight].content !== '' &&
                    <div
                        className="hl_text"
                        dangerouslySetInnerHTML={this.createMarkup(this.props.features.highlights[this.state.activeHighlight].content)}>
                    </div>
                    }
                </section>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/studio/ui/overlay.js